var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22.5416H23.5104V22.552H23.5V22.5416Z",
    stroke: "white",
    strokeWidth: 3.59375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4998 33.0834L28.7707 27.8125C29.8131 26.7701 30.523 25.4419 30.8105 23.996C31.0981 22.5501 30.9505 21.0514 30.3863 19.6894C29.8221 18.3274 28.8667 17.1632 27.641 16.3442C26.4152 15.5252 24.974 15.088 23.4998 15.088C22.0256 15.088 20.5845 15.5252 19.3587 16.3442C18.1329 17.1632 17.1775 18.3274 16.6133 19.6894C16.0492 21.0514 15.9015 22.5501 16.1891 23.996C16.4767 25.4419 17.1866 26.7701 18.229 27.8125L23.4998 33.0834Z",
    stroke: "white",
    strokeWidth: 2.39583,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLocation);
export default __webpack_public_path__ + "static/media/ButtonLocation.2a624160656c65480a75a7e5e792cf57.svg";
export { ForwardRef as ReactComponent };